(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pbb-fall-product"] && !Shopify.designMode) return;
  try {
    
function preparePbbGallery(scope) {
  const thumbs = [...scope.querySelectorAll('[data-pbb-gallery-image]')];
  return color => {
    let first = null;
    thumbs.forEach(thumb => {
      thumb.hidden = thumb.dataset.pbbGalleryColor !== color;
      if (!thumb.hidden && first === null) first = thumb;
    });
    return first;
  };
}
function initPbbProduct(root) {
  root.querySelectorAll('.product-description table').forEach(table => table.remove());
  root.querySelectorAll('.native-variant-select').forEach(select => {
    if (select.dataset.ready) return;
    select.dataset.ready = 'true';
    const scope = select.closest('.pbb-fall');
    const options = [...select.options];
    const filterGallery = preparePbbGallery(scope);
    const sync = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      scope.querySelector('[data-selected-color]').textContent = option.dataset.color;
      scope.querySelector('[data-selected-size]').textContent = option.dataset.size;
      scope.querySelectorAll('[data-pbb-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pbbColor === option.dataset.color)));
      scope.querySelectorAll('[data-pbb-size]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.pbbSize === option.dataset.size));
        button.disabled = !options.some(candidate => candidate.dataset.color === option.dataset.color && candidate.dataset.size === button.dataset.pbbSize && candidate.dataset.available === 'true');
      });
      const first = filterGallery(option.dataset.color);
      const visibleThumbs = [...scope.querySelectorAll('[data-pbb-gallery-image]:not([hidden])')];
      const handle = scope.dataset.pbbProductHandle;
      const modelView = (handle === 'copy-of-project-be-better-t-shirt' && option.dataset.color !== 'Soft Cream') || (handle === 'be-better-hoodie-xxvi-iii' && option.dataset.color !== 'Dark Chocolate') ? 'view 3 of' : 'view 1 of';
      const modelThumb = visibleThumbs.find(thumb => thumb.querySelector('img')?.alt.includes(modelView));
      const selectedImage = modelThumb?.dataset.pbbGalleryImage || option.dataset.image || first?.dataset.pbbGalleryImage;
      const image = scope.querySelector('.product-main-image img');
      if (image && selectedImage) {
        image.src = selectedImage;
        image.removeAttribute('srcset');
        const zoom = scope.querySelector('.pbb-gallery-zoom');
        if (zoom) zoom.href = selectedImage;
      }
      const selectedThumb = visibleThumbs.find(thumb => thumb.dataset.pbbGalleryImage === selectedImage) || first;
      if (image && selectedThumb) image.alt = selectedThumb.querySelector('img')?.alt || image.alt;
      scope.querySelectorAll('[data-pbb-gallery-image]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === selectedThumb)));
      scope.querySelector('.pdp-price').textContent = option.dataset.price;
      scope.querySelector('.native-add').disabled = option.dataset.available !== 'true';
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState(null, '', url);
    };
    scope.querySelectorAll('[data-pbb-color],[data-pbb-size]').forEach(button => button.addEventListener('click', () => {
      const current = select.selectedOptions[0];
      const color = button.dataset.pbbColor || current.dataset.color;
      const size = button.dataset.pbbSize || current.dataset.size;
      let match = options.find(candidate => candidate.dataset.color === color && candidate.dataset.size === size && candidate.dataset.available === 'true');
      if (!match) match = options.find(candidate => candidate.dataset.color === color && candidate.dataset.available === 'true');
      if (match) { select.value = match.value; sync(); }
    }));
    select.addEventListener('change', sync);
    sync();
  });
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-pbb-gallery-image]');
  if (!button) return;
  const root = button.closest('.pbb-fall');
  const image = root.querySelector('.product-main-image img');
  if (image) {
    image.src = button.dataset.pbbGalleryImage;
    image.removeAttribute('srcset');
    image.alt = button.querySelector('img')?.alt || image.alt;
    const zoom = root.querySelector('.pbb-gallery-zoom');
    if (zoom) zoom.href = button.dataset.pbbGalleryImage;
  }
  root.querySelectorAll('[data-pbb-gallery-image]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
});
initPbbProduct(document);
document.addEventListener('shopify:section:load', event => initPbbProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
